<template>
  <div class="bg">
    <div class="bg-color"></div>
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-md-5 col-lg-4 mx-auto mt-10 box">
          <div class="login-form mt-3 mt-md-0 mx-auto col-md-12 col-lg-10">
            <div style="text-align: center">
              <img
                style="margin-bottom: 10px; margin-top: 50px"
                src="../../img/logoTeros.png"
                width="250px"
              />
            </div>

            <template v-if="!sended">
              <kinput
                type="text"
                key="org1"
                rules="required"
                v-model="usuario"
                placeholder="Informe o seu usuário"
              >
                Usuário
              </kinput>

              <template v-if="usuario">
                <p class="aviso-senha">Uma vez que a solicitação for enviada, sua senha antiga é invalidada.</p>

                <p class="aviso-senha">Mesmo que você relembre ela, não poderá mais utiliza-la para acessar a plataforma Teros.</p>
              </template>

              <div class="mx-auto">
                <div style="text-align: center">
                  <button
                    @click="doReset()"
                    class="btn btn-galapos"
                    style="background-color: #008180; color: #FFF"
                    type="submit"
                    :disabled="!usuario"
                  >
                    <span class="font-weight-medium">REDEFINIR SENHA</span>
                    <!-- <v-icon small color="#FFF">mdi-chevron-right</v-icon> -->
                  </button>
                </div>
              </div>
            </template>
            <template v-else>
              <v-sheet rounded class="p-3 pb-1">
                <p>Solicitação aceita. Por favor, utilize o link enviado para o seu e-mail para criar uma nova senha.</p>
                <p>O link possui validade de <b>15 minutos</b>.</p>
                <p>Caso não identifique o recebimento do e-mail, por favor, entre em contato com a Galapos.</p>
              </v-sheet>
            </template>

            <v-col cols="12" class="text-center d-flex justify-end align-center flex-column mt-10">
              <p class="text-white mb-n10">criado por</p>
              <img width="300px" alt="galapos-logo" src="../../img/logoGalaposBranco.svg" />
            </v-col>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created: function () {
    const { usuario } = this.$route.query;

    if (usuario) {
      this.usuario = usuario;
    }
  },
  components: {
    kinput: () => import("@/components/kInput.vue"),
  },
  computed: {
    resourceReset: function () {
      return this.apiResource(`/v1/recuperarSenha?usuario=${this.usuario}`);
    },
    fields: function () {
      return {
        email: {
          key: "usuario",
          name: "Usuário",
          type: this.$fieldTypes.TEXT,
        },
      };
    },
  },
  data: function () {
    return {
      sended: false,
      isErrorMessage: false,
      usuario: "",
    };
  },
  methods: {
    doReset: function () {
      if (this.usuario) {
        this.isErrorMessage = false;
        this.resourceReset.get()
          .then(() => {
            this.sended = true;
          })
          .catch((e) => {
            this.isErrorMessage = e.response.status;
          });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.bg {
  background: url("../../img/bg_compressed.webp") center;
  background-size: cover;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.bg-color {
  background-color: rgba(0, 0, 0, 0.5);
  &:after {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    content: " ";
    background: rgba(0, 0, 0, 0.5);
  }
}

.btn-galapos {
  background: #7dbacc;
  box-shadow: 0px 8px 16px rgba(0, 126, 255, 0.16);
  border-radius: 8px;
  color: white;
}

.aviso-senha {
  color: white;
}

.link-primary {
  color: #007bff !important;
}
</style>
